<template>
  <div id="app">
    <router-view style="padding-bottom: 50px;"></router-view>
    <van-tabbar v-model="activeTabbar" v-if="false" safe-area-inset-bottom v-show="hidshow" @change="onChange">
      <van-tabbar-item name="due-diligence" icon="orders-o">
        尽调
      </van-tabbar-item>
      <van-tabbar-item name="contract" icon="records">
        合同
      </van-tabbar-item>
      <van-tabbar-item name="message" icon="comment-o">
        消息
      </van-tabbar-item>
      <van-tabbar-item name="mine" icon="user-o">
        我的
      </van-tabbar-item>
    </van-tabbar>
    <!-- 版本更新弹框 -->
    <my-updateapp-dialog :appVersionCode="appVersionCode" :downloadUrl="downloadUrl" :description="description" :forceUpdate="forceUpdate"></my-updateapp-dialog>
  </div>
</template>

<script>
import updateAppDialog from '@/components/updateAppDialog'
import { getAppVersion } from '@/mixin/getAppVersion'
import { getRatio } from '@/mixin/getRatio'
import { getDeviceInfo } from '@/mixin/getDeviceInfo'
import { setShowBackView } from '@/mixin/setShowBackView'
import $ from 'jquery'

export default {
  data () {
    return {
      appVersionCode: '', // App最新版本号
      downloadUrl: '', // App下载地址
      description: '', // App下载地址
      forceUpdate: '', // 是否强更
      hidshow: true, // 显示或者隐藏tabbar
      authNo: ''
    }
  },
  computed: {
    // 当前选择的TABBAR
    activeTabbar: {
      get () {
        return this.$store.state.global.activeTabbar
      },
      set (val) {
        this.$store.commit('global/SET_ACTIVETABBAR', val)
      }
    },
    accessToken () {
      return this.$store.state.authentication.accessToken
    },
    verificationReturnUrl () {
      return this.$store.state.authentication.verificationReturnUrl
    },
    sourcechannel () {
      return this.$store.state.global.sourcechannel || ''
    },
    authenticationInfo () {
      return this.$store.state.authentication.authenticationInfo
    }
  },
  mounted () {
    let that = this
    // 禁止手机端扩大和缩小手势
    window.onload = function () {
      document.addEventListener('touchstart', function (event) {
        if (event.touches.length > 1) {
          event.preventDefault()
        }
      })
      document.addEventListener('gesturestart', function (event) {
        event.preventDefault()
      })
    }
    // 人脸认证的回调
    window.callJsFaceVerifyResult = function (resData) {
      let res = that.$terminal === 'Android' ? JSON.parse(resData) : resData
      if (res.IdentityCallBackResult && res.IdentityCallBackResult.code === '0') {
        // App返回人脸认证成功，再次调用后端查看认证结果
        that.$store.commit('authentication/SET_APPVERIFICATIONCODE', res.IdentityCallBackResult.code)
        that.fetchVerificationQuery()
      } else {
        that.$toast(`${res.IdentityCallBackResult.msg}`)
        if (window.location.origin === 'http://test.m-credit-due-diligence.jd.com') {
          that.$store.commit('authentication/SET_APPVERIFICATIONCODE', '0')
          that.fetchVerificationQuery()
        } else if (that.$terminal === 'IOS' && !that.sourcechannel) {
          let userNo = that.authenticationInfo.userNo
          if (userNo === 'C1006571728' || userNo === 'C1000567420') {
            that.$store.commit('authentication/SET_APPVERIFICATIONCODE', '0')
            that.fetchVerificationQuery()
          }
        }
      }
    }
    // 获取App的版本号的回调
    window.callJsAppVersion = function (resData) {
      let res = that.$terminal === 'Android' ? JSON.parse(resData) : resData
      that.$store.commit('global/SET_APPVERSION', res.AppVersion)
      if (window.location.href === 'http://test.m-credit-due-diligence.jd.com/' || window.location.href === 'https://m-due-diligence.jd.com/') {
        let params = {
          osType: that.$terminal,
          versionName: res.AppVersion
        }
        that.fetchAppNewVersion(params)
      }
    }
    // 获取手机分辨率的回调
    window.callJsRatio = function (res) {
      let { screenWidth, screenHeight } = res.screen
      that.$store.commit('global/SET_RATIO', res.screen)
      that.setIphoneScreen(screenWidth, screenHeight)
    }
    // 获取设备权限的回调
    window.callJsPermissionState = function (resData) {
      let res = that.$terminal === 'Android' ? JSON.parse(resData) : resData
      let permissionType = res.permissionType
      let state = res.state
      if (permissionType.indexOf('ACCESS_COARSE_LOCATION') >= 0) {
        that.$store.commit('global/SET_LOCATIONSTATE', state)
      } else if (permissionType.indexOf('CAMERA') >= 0) {
        that.$store.commit('global/SET_CAMERASTATE', state)
      } else if (permissionType.indexOf('RECORD_AUDIO') >= 0) {
        that.$store.commit('global/SET_AUDIOSTATE', state)
      } else if (permissionType.indexOf('WRITE_EXTERNAL_STORAGE') >= 0) {
        that.$store.commit('global/SET_STORAGESTATE', state)
      }
    }
    // 原生回调h5
    window.callJSForjson = function (resData) {
      let res = that.$terminal === 'Android' ? JSON.parse(resData) : resData
      let { param } = res
      if (param.event === 'getDeviceInfo') {
        that.$store.commit('global/SET_DEVICEMODEL', param.deviceModel)
        that.$store.commit('global/SET_DEVICEID', param.deviceId)
      }
    }
    // 原生回调h5
    window.callJSForDeviceInfo = function (resData) {
      let res = that.$terminal === 'Android' ? JSON.parse(resData) : resData
      that.$store.commit('global/SET_DEVICEMODEL', res.deviceModel)
      that.$store.commit('global/SET_DEVICEID', res.deviceId)
    }
    // 判断来源
    that.getSourcechannel()
  },
  methods: {
    // 判断来源
    getSourcechannel () {
      this.$toast.setDefaultOptions({ duration: 5000 })
      let sourcechannel = this.GetQueryString('sourcechannel')
      // 如果是从京东金融或者企业金融进来
      if (sourcechannel === 'JDJRAPP') {
        this.setJDJRAPP()
      } else if (sourcechannel === 'JBFAPP') {
        // 如果是企业金融App进来的
        this.setJBFAPP()
      } else if (this.GetQueryString('authNo') || window.location.href.indexOf('survey-e') > 0) {
        // 如果是从鉴权返回
        this.authNo = this.GetQueryString('authNo')
        this.setJBFAPP()
      } else {
        // 如果是从鲸晓App进来
        this.init()
      }
    },
    async getAccessKeyNew() {
      const result = await this.$asyncCall('getAccessKeyNew')
      const str = `${result}`
      const resdata = JSON.parse(str)
      if (resdata.resultCode === 0) {
        let {accessKey, deviceId, deviceInfo} = resdata.resultData
        window.localStorage.setItem('Authorization', accessKey)
        window.localStorage.setItem('deviceId', deviceId)
        window.localStorage.setItem('deviceName', deviceInfo.deviceName)
        window.localStorage.setItem('clientVersion', deviceInfo.clientVersion)
        // 兼容刘海屏，设置导航条高度
        let screen = deviceInfo.screen
        if (screen && this.$terminal === 'IOS') {
          let screenWidth = screen.split('*')[0]
          let screenHeight = screen.split('*')[1]
          this.setIphoneScreen(Number(screenWidth), Number(screenHeight))
        }
        // 如果有鉴权流水号，则查看人脸结果
        if (this.authNo) {
          this.checkAuthStatus()
        } else {
          this.$router.push('/survey-e')
        }
      } else {
        this.$toast.fail(resdata.resultMsg || 'getAccessKeyNew失败')
      }
    },
    // 如果是企业金融App进来的
    setJDJRAPP () {
      window.localStorage.setItem('sourcechannel', 'JDJRAPP')
      this.$store.commit('global/SET_SOURCECHANNEL', 'JDJRAPP')
      // let channel = this.GetQueryString('channel') || 'A'
      window.localStorage.setItem('channel', 'A')
      this.$store.commit('global/SET_CHANNEL', 'A')
      this.$router.push('/survey/myquestionnaire')
      window.JrBridge && window.JrBridge.callNative({
        type: '2',
        data: '企业主贷贷款用途证明'
      })
    },
    // 如果是企业金融App进来的
    setJBFAPP () {
      // 隐藏企业金融的导航条
      this.$asyncCall('hideNaviBar', JSON.stringify({'hide': true}))
      window.localStorage.setItem('sourcechannel', 'JBFAPP')
      this.$store.commit('global/SET_SOURCECHANNEL', 'JBFAPP')
      window.localStorage.setItem('channel', '')
      this.$store.commit('global/SET_CHANNEL', '')
      this.getAccessKeyNew()
    },
    // 如果是从鲸晓App进来
    init () {
      // 隐藏App返回条
      this.setShowBackView(0, this.$serverconfig.VUE_APP_REDIRECT)
      this.$store.commit('global/SET_SOURCECHANNEL', '')
      // 如果是IOS判断来源
      if (this.$terminal === 'IOS') {
        // 查看当前手机的分辨率
        this.getRatio()
      } else {
        this.getDeviceInfo()
      }
      this.$router.push('/guide')
      // this.$dialog.alert({
      //   message: '请下载企业东东家App！',
      //   theme: 'round-button'
      // }).then(() => {
      //   // on close
      // })
      // 查看当前App版本
      // this.getAppVersion()
      // this.fetchCheckCustManager()
    },
    // 改变tabbar
    onChange (index) {
      this.$store.commit('global/SET_ACTIVETABBAR', index)
      this.$router.push('/' + index)
    },
    // 查看人脸结果
    checkAuthStatus () {
      // 更新角色为尽调员
      this.$store.commit('survey/SET_SURVEYROLE', 'INVESTIGATOR')
      let authStatus = this.GetQueryString('authStatus')
      let code = authStatus === '2' ? '0' : '1'
      // 设置本地App鉴权结果
      this.$store.commit('authentication/SET_APPVERIFICATIONCODE', code)
      // 设置本地鉴权流水号
      this.$store.commit('authentication/SET_ACCESSTOKEN', this.authNo)
      // App返回人脸认证成功，再次调用后端查看认证结果
      this.fetchVerificationQuery2()
    },
    // 跳转页面
    goRedirect (verificationStatus) {
      let attach = this.GetQueryString('attach')
      let paperNo = ''
      let surveyNo = ''
      if (attach && attach.split('-')) {
        paperNo = attach.split('-')[0]
        surveyNo = attach.split('-')[1]
      }
      if (paperNo && surveyNo) {
        if (verificationStatus === 'success') {
          this.$router.push({
            path: '/survey-e/questionnaire',
            query: {
              paperNo,
              surveyNo
            }
          })
        } else {
          this.$router.push({
            path: '/survey-e/myquestionnaire/creat-authinfo',
            query: {
              paperNo,
              surveyNo
            }
          })
        }
      } else {
        this.$router.push({
          path: '/survey-e/agentQuestionnaire'
        })
      }
    },
    // 查看人脸结果
    fetchVerificationQuery () {
      this.$store.dispatch('authentication/fetchVerificationQuery', { accessToken: this.accessToken }).then(data => {
        if (!data || data.verificationStatus !== 'success') {
          // 核身失败
          this.$toast(`认证失败`)
        } else if (data.verificationStatus === 'success') {
          if (this.verificationReturnUrl) {
            this.$router.push(this.verificationReturnUrl)
          }
        }
      })
    },
    // 查看人脸结果-企业金融
    fetchVerificationQuery2 () {
      this.$store.dispatch('authentication/fetchVerificationQuery', { accessToken: this.authNo }).then(data => {
        if (!data || data.verificationStatus !== 'success') {
          // 核身失败
          this.$toast(`认证失败`)
        }
        this.goRedirect(data.verificationStatus)
      })
    },
    // 查看是否是最新版本
    fetchAppNewVersion (params) {
      this.$store.dispatch('home/fetchAppNewVersion', params).then(data => {
        if (data && data.versionName) {
          // 如果存在返回结果，说明不是最新版本
          this.appVersionCode = data.versionName
          this.forceUpdate = data.forceUpdate
          this.downloadUrl = this.$serverconfig.VUE_APP_REDIRECT + '/static/download.html'
          this.description = data.description
          this.$store.commit('global/SET_UPDATEAOODIALOG', true)
        } else {
          this.$router.push('/mine')
        }
      })
    },
    // 客户经理白名单查询
    fetchCheckCustManager () {
      this.$store.dispatch('survey/fetchCheckCustManager')
    },
    // 设置苹果手机的样式
    setIphoneScreen (screenWidth, screenHeight) {
      if (screenWidth === 320 && screenHeight === 568) {
        $('#app').css({
          'margin-top': '15px',
          'min-height': '553px'
        })
      } else if (screenWidth === 375 && screenHeight === 667) {
        $('#app').css({
          'margin-top': '20px',
          'min-height': '647px'
        })
      } else if (screenWidth === 414 && screenHeight === 736) {
        $('#app').css({
          'margin-top': '20px',
          'min-height': '716px'
        })
      } else if (screenWidth === 375 && screenHeight === 812) {
        $('#app').css({
          'margin-top': '30px',
          'min-height': '762px'
        })
      } else if (screenWidth === 414 && screenHeight === 896) {
        $('#app').css({
          'margin-top': '30px',
          'min-height': '846px'
        })
      } else if (screenWidth === 621 && screenHeight === 1344) {
        $('#app').css({
          'margin-top': '60px',
          'min-height': '1244px'
        })
      }
    },
    // 获取url地址栏参数
    GetQueryString (parameter) {
      let reg = new RegExp('(^|&)' + parameter + '=([^&]*)(&|$)')
      let r = window.location.search.substr(1).match(reg)
      if (r != null) {
        return unescape(r[2])
      }
      return false
    }
  },
  components: {
    'my-updateapp-dialog': updateAppDialog
  },
  watch: {
    $route(to, from) {
      if (this.$terminal === 'Android' && from.name === 'survey-e' && to.path === '/') {
        this.$asyncCall('closePage')
      }
    }
  },
  mixins: [getAppVersion, getRatio, setShowBackView, getDeviceInfo]
}
</script>

<style lang="less">
#app {
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue